import { z } from 'zod';

export const editClientAdminUserSchema = z
  .object({
    fullName: z.string().min(1, '氏名は必須です。'),
    email: z
      .string()
      .email('有効なメールアドレスを入力してください。')
      .min(1, 'メールアドレスは必須です。'),
    password: z
      .string()
      .min(8, 'パスワードは8文字以上である必要があります。')
      .optional()
      .or(z.literal('')),
    passwordConfirmation: z.string().optional().or(z.literal('')),
  })
  .refine(
    data => {
      if (data.password && data.password.length > 0) {
        return data.password === data.passwordConfirmation;
      }
      return true;
    },
    {
      message: 'パスワードが一致しません。',
      path: ['passwordConfirmation'],
    }
  );

export type EditClientAdminUserFormFieldValues = z.infer<typeof editClientAdminUserSchema>;
